import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';

import { TipoLancamento } from '@models/tipo-lancamento';
import { CadastroLoteComponent } from './cadastro-lote/cadastro-lote.component';
import { Permissao } from '@models/enums/permissao';

@Component({
  selector: 'app-cadastro-lote-lancamentos',
  standalone: false,
  templateUrl: './cadastro-lote-lancamentos.component.html',
  styleUrl: './cadastro-lote-lancamentos.component.scss'
})
export class CadastroLoteLancamentosComponent implements OnInit, AfterViewInit {

  protected get permissaoEditarLancamento() { return Permissao.EDITAR_LANCAMENTO_CAIXA; }

  title: string = "Lançamento em lote";

  tiposLancamento: TipoLancamento[] = [];

  @ViewChild(CadastroLoteComponent)
  cadastroLote: CadastroLoteComponent;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: Data) => {
      const dados = data['tiposLancamento'];
      this.tiposLancamento = dados;
    });
  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      const nome = params['nome'];
      const data = params['data'];

      if (nome && data) {
        this.cadastroLote.buscar(nome, data);
      }
      else if (data) {
        this.cadastroLote.setDataInicial(new Date(data));
      }
    });
  }

  public onLoteEncontrado(): void {
    this.title = "Editar lote de lançamentos";
  }

  public voltarClick(): void {
    const dataLote: Date | null = this.cadastroLote.form.get('dataLote')?.value;
    this.router.navigate(['/movimentacao-caixa'], {
      queryParams: { data: this.formatarData(dataLote ?? new Date()) }
    });
  }

  public salvarClick(): void {
    const dataLote: Date = this.cadastroLote.form.get('dataLote')?.value;
    this.cadastroLote.salvar(() => this.router.navigate(['/movimentacao-caixa'], {
      queryParams: { data: this.formatarData(dataLote) }
    }));
  }

  private formatarData(data: Date): string {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  public salvarENovoClick(): void {
    this.cadastroLote.salvar(() => this.resetForm());
  }

  private resetForm(): void {
    this.title = 'Lançamento em lote';
    this.cadastroLote.resetForm();
    this.router.navigate([], { relativeTo: this.route, queryParams: {}, replaceUrl: true });
  }
}
